import type {ReactElement} from 'react';
import {BottomBarItem} from '@Components/contextual-menu/components/bottom-bar-item';
import {openFormMakerMobileControlModal} from '@Modals/form-maker-mobile-control-modal/form-maker-mobile-control-modal';
import {TileComplexity} from '@FormMakerReact/lib/form-maker-tile-meta-library.types';
import type {ControlTileProps} from './control-tile.types';

export function ControlTile({entry}: ControlTileProps): ReactElement {
  const {meta} = entry;
  const label = window.i18next.t(meta.labelKey);
  const onClick = (): void => {
    openFormMakerMobileControlModal({
      labelKey: meta.labelKey,
      isFullHeight: meta.complexity === TileComplexity.COMPLEX,
    });
  };
  return <BottomBarItem id={`form-maker-tile-${meta.labelKey}`} icon={meta.icon} text={label} onClick={onClick} />;
}
